import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const WidthMaximize = ({ defaultWidth = "80%", onToggle }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  const toggleMaximize = () => {
    const newMaximized = !isMaximized;
    setIsMaximized(newMaximized);
    const width = newMaximized ? "100vw" : defaultWidth;
    onToggle?.(width);
  };

  useEffect(() => {
    // Inform parent on initial render
    onToggle?.(defaultWidth);
  }, []);

  return (
    <IconButton onClick={toggleMaximize} size="small">
      {isMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </IconButton>
  );
};

export default WidthMaximize;
